import CheckIcon from "@/assets/svgs/CheckIcon";
import CtaButtonGroup, { CtaType } from "@/components/molecules/CtaButtonGroup";
import classNames from "classnames";
import Heading from "../atoms/Heading";
import HeroPill from "../atoms/HeroPill";
import { SectionHeadingType } from "../atoms/SectionHeading";

export enum GraphyPlanType {
  Launch = "Launch",
  Rise = "Rise",
  Scale = "Scale",
}
export type PaidFeaturesSectionPropType = {
  title: SectionHeadingType;
  points: string[];
  plans: {
    planName: GraphyPlanType;
    amount: { india: string; global: string };
    billingCycle: string;
    graphyShare: { value: string; text: string };
    bestFor: string;
    cta: CtaType;
  }[];
  countryCode: string;
};

const PaidFeaturesSection = ({
  title,
  points,
  plans,
  countryCode,
}: PaidFeaturesSectionPropType) => {
  if (countryCode == "KR") return null;
  return (
    <div className="container flex flex-col items-center justify-center gap-8 sm:gap-6">
      <div className=" flex flex-col items-center justify-center gap-4">
        <Heading
          heading={title}
          as="h2"
          fontStyle="text-title-20 sm:text-title-32"
        />

        <div className="flex w-full flex-col flex-wrap justify-start gap-x-6 gap-y-2  md:flex-row  md:justify-center">
          {points.map((point, index) => (
            <div
              className="flex  items-center gap-2 whitespace-nowrap"
              key={index}
            >
              <div className="flex-shrink-0">
                <CheckIcon />
              </div>
              <p className="text-body-16 text-grey-4">{point}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 overflow-hidden  rounded-3xl border border-grey-4 md:w-[700px]">
        {plans.map(
          (
            { planName, amount, billingCycle, graphyShare, bestFor, cta },
            index
          ) => (
            <div
              key={index}
              className={classNames(
                "flex flex-col justify-between gap-6 p-6 ",
                {
                  "bg-[#050B24] bg-primary-gradient":
                    planName === GraphyPlanType.Rise,
                },
                { "text-grey-0": planName === GraphyPlanType.Rise },
                { "text-grey-4": planName === GraphyPlanType.Launch }
              )}
            >
              <div className="flex flex-grow flex-col items-center justify-center gap-1 sm:flex-grow-0">
                <HeroPill
                  category={planName}
                  className={
                    planName === GraphyPlanType.Launch ? "!bg-purple-0 " : ""
                  }
                  textColor={
                    planName === GraphyPlanType.Launch ? "text-grey-4" : ""
                  }
                />
                <div className="text-title-32">
                  {countryCode === "IN" ? amount.india : amount.global}
                </div>
                <div className="text-body-14 opacity-70">{billingCycle}</div>
              </div>
              <div className={`flex flex-col gap-2`}>
                <div className="flex items-end justify-center gap-1">
                  <div className="text-center text-body-24 font-semibold">
                    {graphyShare.value}
                  </div>
                  <div className="text-center text-body-16">
                    {graphyShare.text}
                  </div>
                </div>
                <div
                  className={`text-center text-body-14 ${
                    planName === GraphyPlanType.Launch
                      ? "text-grey-3"
                      : "text-grey-2 opacity-70"
                  }`}
                >
                  {bestFor}
                </div>
                <div
                  className={`flex ${
                    planName === GraphyPlanType.Rise && "text-grey-4"
                  }`}
                >
                  <CtaButtonGroup ctas={[cta]} align="stretch" />
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default PaidFeaturesSection;
